module.exports = __webpack_public_path__ + "static/media/brazil.f58a13e8.svg";